import { useState, useEffect } from "react";
import { StyledEmailSettings } from "./index.styled";
import SettingsSectionTitle from "../SettingsSectionTitle";
import EmailIcon from "../../../assets/icons/email.webp";
import ExchangeIcon from "../../../assets/icons/exchange.png";
import AtIcon from "../../../assets/icons/@.webp";
import { initiateOAuthConnection } from "../../../utils/apiService";
import { useAppSelector } from "../../../hooks/redux";

interface EmailSettingsProps {
  connectionsData?: {
    success: boolean;
    message: string;
    data: Array<{
      ID: number;
      UpdatedAt: string;
      DeletedAt: string | null;
      id: string;
      state: string;
      email: string;
      status_id: number;
      CreatedAt: string;
    }>;
  };
}

const EmailSettings = ({ connectionsData }: EmailSettingsProps) => {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  // Get status ID from Redux store
  const statusId = useAppSelector((state) => state.dashboard.status?.id);

  // Update email when connections data is available
  useEffect(() => {
    if (connectionsData?.success && connectionsData?.data?.length > 0) {
      // Get all unique emails from connections
      const emails = connectionsData.data
        .map((connection) => connection.email)
        .filter((email, index, self) => email && self.indexOf(email) === index);

      if (emails.length > 0) {
        // Display all emails separated by comma
        const allEmails = emails.join(", ");
        console.log("Setting emails from connections data:", allEmails);
        setEmail(allEmails);
      }
    }
  }, [connectionsData]);

  const handleExchangeClick = async () => {
    if (isLoading) return;

    try {
      setIsLoading(true);

      if (!statusId) {
        console.error("No status ID found in Redux store for OAuth connection");
        return;
      }

      // Call the API to initiate OAuth connection
      const response = await initiateOAuthConnection(statusId);

      if (response.success && response.data?.id) {
        // Create the OAuth URL with the connection ID
        const authUrl = `https://auth.twist.bot/auth/google/login?id=${response.data.id}&r=true`;

        // Open OAuth URL in a popup window
        const popup = window.open(
          authUrl,
          "oauth_popup",
          "width=600,height=600,scrollbars=yes,resizable=yes"
        );

        if (!popup) {
          console.error(
            "Failed to open popup window. Please check your browser settings."
          );
          return;
        }

        // Focus the popup window
        popup.focus();

        // Listen for popup close to refresh the page or update data
        const checkClosed = setInterval(() => {
          if (popup.closed) {
            clearInterval(checkClosed);
            // Optionally refresh the page or reload data
            window.location.reload();
          }
        }, 1000);
      } else {
        console.error("OAuth connection failed:", response.message);
      }
    } catch (error) {
      console.error("Error initiating OAuth connection:", error);
    } finally {
      setIsLoading(false);
    }
  };

  // Email field is read-only, no need for change handlers

  return (
    <StyledEmailSettings>
      <SettingsSectionTitle
        title="כתובת דוא״ל"
        icon={EmailIcon}
        iconHeight={13}
      />
      <div className="email-settings-input-container">
        <div
          className="email-settings-input-image"
          onClick={handleExchangeClick}
          style={{
            cursor: isLoading ? "not-allowed" : "pointer",
            opacity: isLoading ? 0.6 : 1,
          }}
        >
          <img src={ExchangeIcon} alt="exchange" />
        </div>
        <div className="email-input-wrapper">
          <input
            type="email"
            placeholder="example@gmail.com"
            value={email}
            readOnly
            disabled
          />
          <div className="email-at-icon">
            <img src={AtIcon} alt="at" />
          </div>
        </div>
      </div>
    </StyledEmailSettings>
  );
};

export default EmailSettings;
